// DO NOT EDIT -- generated from fs/services/eraser/eraser_public.proto

import * as fullstory_operations_v1 from '../../api/fullstoryapis/operations/v1';
import * as protobuf from '../../../google/protobuf';

export namespace EraserPublic {

  export const QueryIndividualEndpoint = "/grpc/eraser.EraserPublic/QueryIndividual";
  /** QueryIndividual return details about an identified user, given the uid. */
  export function QueryIndividual(sender: (req: IndividualRequest, endpoint: string) => Promise<IndividualDetails>, req: IndividualRequest): { promise: () => Promise<IndividualDetails>, endpoint: string } {
    return {
      promise: () => sender(req, QueryIndividualEndpoint),
      endpoint: QueryIndividualEndpoint
    };
  }

  export const QueryUserEndpoint = "/grpc/eraser.EraserPublic/QueryUser";
  /**
   * QueryUser return details about an anonymous user, given the autogenerated
   * numeric ID of the user.
   */
  export function QueryUser(sender: (req: UserRequest, endpoint: string) => Promise<IndividualDetails>, req: UserRequest): { promise: () => Promise<IndividualDetails>, endpoint: string } {
    return {
      promise: () => sender(req, QueryUserEndpoint),
      endpoint: QueryUserEndpoint
    };
  }

  export const DeleteIndividualEndpoint = "/grpc/eraser.EraserPublic/DeleteIndividual";
  /**
   * DeleteIndividual deletes all data associated with the identified user, for
   * the given uid. Deletion includes user's properties and user's sessions.
   * This is an asynchronous operation, and the deletion will eventually be
   * completed.
   */
  export function DeleteIndividual(sender: (req: IndividualRequest, endpoint: string) => Promise<OperationId>, req: IndividualRequest): { promise: () => Promise<OperationId>, endpoint: string } {
    return {
      promise: () => sender(req, DeleteIndividualEndpoint),
      endpoint: DeleteIndividualEndpoint
    };
  }

  export const DeleteUserEndpoint = "/grpc/eraser.EraserPublic/DeleteUser";
  /**
   * DeleteUser deletes all data associated with the anonymous user, for
   * the given user_id. Deletion includes user's properties and user's sessions.
   * This is an asynchronous operation, and the deletion will eventually be
   * completed.
   */
  export function DeleteUser(sender: (req: UserRequest, endpoint: string) => Promise<OperationId>, req: UserRequest): { promise: () => Promise<OperationId>, endpoint: string } {
    return {
      promise: () => sender(req, DeleteUserEndpoint),
      endpoint: DeleteUserEndpoint
    };
  }

  export const DeleteSessionEndpoint = "/grpc/eraser.EraserPublic/DeleteSession";
  /**
   * DeleteSession deletes a single session given the session ID.
   * This is an asynchronous operation, and the deletion will eventually be
   * completed.
   */
  export function DeleteSession(sender: (req: DeleteSessionRequest, endpoint: string) => Promise<OperationId>, req: DeleteSessionRequest): { promise: () => Promise<OperationId>, endpoint: string } {
    return {
      promise: () => sender(req, DeleteSessionEndpoint),
      endpoint: DeleteSessionEndpoint
    };
  }

  export const DeleteSegmentEndpoint = "/grpc/eraser.EraserPublic/DeleteSegment";
  /**
   * DeleteSegment deletes sessions that belong to the segment identified by the
   * given unnamed segment URL. Deletes only the sessions, and does not include
   * any users' properties.
   * This is an asynchronous operation, and the deletion will eventually be
   * completed.
   */
  export function DeleteSegment(sender: (req: DeleteSegmentRequest, endpoint: string) => Promise<OperationId>, req: DeleteSegmentRequest): { promise: () => Promise<OperationId>, endpoint: string } {
    return {
      promise: () => sender(req, DeleteSegmentEndpoint),
      endpoint: DeleteSegmentEndpoint
    };
  }

  export const GetOperationStatusEndpoint = "/grpc/eraser.EraserPublic/GetOperationStatus";
  export function GetOperationStatus(sender: (req: OperationId, endpoint: string) => Promise<fullstory_operations_v1.Operation>, req: OperationId): { promise: () => Promise<fullstory_operations_v1.Operation>, endpoint: string } {
    return {
      promise: () => sender(req, GetOperationStatusEndpoint),
      endpoint: GetOperationStatusEndpoint
    };
  }

  export const ListOperationsEndpoint = "/grpc/eraser.EraserPublic/ListOperations";
  export function ListOperations(sender: (req: ListOperationsRequest, endpoint: string) => Promise<fullstory_operations_v1.ListOperationsResponse>, req: ListOperationsRequest): { promise: () => Promise<fullstory_operations_v1.ListOperationsResponse>, endpoint: string } {
    return {
      promise: () => sender(req, ListOperationsEndpoint),
      endpoint: ListOperationsEndpoint
    };
  }
}

export interface DeleteSessionRequest {
  orgId: string;
  /**
   * The autogenerated numeric identifier, typically used to identify an
   * anonymous user or a user on a device.
   */
  userId: protobuf.int64;
  sessionId: protobuf.int64;
  skipEmail: boolean;
}

export interface IndividualRequest {
  orgId: string;
  /** The application-specific ID you've given to the user. You will have passed that ID through the [FS.identify](/identify) Browser API function. */
  uid: string;
}

export interface UserRequest {
  orgId: string;
  /**
   * The autogenerated numeric identifier, typically used to identify an
   * anonymous user or a user on a device.
   */
  userId: protobuf.int64;
}

/** Response sent as JSON in body */
export interface IndividualDetails {
  numSessions: number;
  /** If this user is already being deleted, this will be set to true. */
  existingOperation: boolean;
}

/**
 * TODO(sanjay): Add a GetOrgId() method to the request struct so that grpcauth can double check the orgId from the
 *   context and request.
 */
export interface DeleteSegmentRequest {
  /**
   * A FullStory app URL pointing to an unnamed segment, i.e. not a saved
   * segment.
   */
  segmentUrl: string;
  comment: string;
}

export interface OperationId {
  id: string;
  orgId: string;
}

export interface ListOperationsRequest {
  paginationToken: string;
  limit: number;
  state: fullstory_operations_v1.OperationState;
  type: fullstory_operations_v1.OperationType;
  orgId: string;
}
